
<div class="form-group">
  <label class="form-group__label">{{question.question_copy}}</label>
  <div class="custom-input--icon-lg__flex-container">
    @for (item of items; track item) {
      <label
        class="custom-input custom-input--icon-lg"
        >
        <input type="radio" [name]="uniqueControlName" (click)="checkRadio(item?.answer ? item?.answer : item)"
          [checked]="item?.answer === question?.answer || item?.answer === selectedValue || item === selectedValue">
          <span class="custom-input__label">
            @if (item?.image_url) {
              <img [src]="item?.image_url ? item?.image_url : ''" class="icon">
            }
            <h5 class="font-16">{{item?.answer ? item.answer : item}}</h5>
          </span>
        </label>
      }

    </div>
  </div>